var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,3H5C3.9,3,3,3.9,3,5v10c0,1.1,0.9,2,2,2h2v5.4l1.7-1.7l3.7-3.7H19c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M20,15 c0.1,0.5-0.3,0.9-0.8,1c-0.1,0-0.1,0-0.2,0h-7l-4,4v-4H5c-0.5,0.1-0.9-0.3-1-0.8c0-0.1,0-0.1,0-0.2V5C3.9,4.5,4.3,4.1,4.8,4 C4.9,4,4.9,4,5,4h14c0.5-0.1,0.9,0.3,1,0.8c0,0.1,0,0.1,0,0.2V15z M9,10c0.1,0.5-0.3,0.9-0.8,1c-0.1,0-0.1,0-0.2,0 c-0.5,0.1-0.9-0.3-1-0.8c0-0.1,0-0.1,0-0.2C6.9,9.5,7.3,9.1,7.8,9C7.9,9,7.9,9,8,9c0.5-0.1,0.9,0.3,1,0.8C9,9.9,9,9.9,9,10z M13,10 c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S13,9.4,13,10z M17,10c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C16.6,9,17,9.4,17,10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItComment);
export default __webpack_public_path__ + "static/media/it-comment.40423c11.svg";
export { ForwardRef as ReactComponent };